import React from 'react';
const PORTAL_SCREENSHOT = 'https://cdn.magicpatterns.com/uploads/3oWsijQDNNtNASnY6S6pbK/image.png';

/** The live Vexu Portal console at console.vexu.ai. */
export function PortalPreview() {
  return <div className="flex h-full w-full items-center justify-center px-[26px]" data-id="element-520" data-mp="a69bdzjkchnp">
      <div className="w-full overflow-hidden rounded-xl border border-slate-900/[0.08] bg-white shadow-[0_18px_44px_-20px_rgba(15,23,42,0.28)]" data-id="element-521" data-mp="f5cf9gnt4hu3">
        {/* Browser chrome */}
        <div className="flex items-center gap-[8px] border-b border-slate-900/[0.06] bg-slate-50 px-[12px] py-[9px]" data-id="element-522" data-mp="3en3o4x3wg2ew">
          <span className="h-[7px] w-[7px] rounded-full bg-slate-300" data-id="element-523" data-mp="3nlp4cllwf5ci" />
          <span className="h-[7px] w-[7px] rounded-full bg-slate-300" data-id="element-524" data-mp="3nnidc7jzi1no" />
          <span className="h-[7px] w-[7px] rounded-full bg-slate-300" data-id="element-525" data-mp="3slbkp3x0x1pj" />
          <span className="ml-[8px] rounded-md bg-white px-[10px] py-[3px] text-[9.5px] font-medium tracking-[0.02em] text-slate-500 ring-1 ring-slate-900/[0.06]" data-id="element-526" data-mp="12vzr2d0ufrlx">
            console.vexu.ai
          </span>
        </div>

        <div className="h-[212px] overflow-hidden bg-white" data-id="element-527" data-mp="3a0n8dqaxl4fe">
          <img src={PORTAL_SCREENSHOT} alt="Vexu Portal conversational AI flow builder with channels, agents and actions" className="h-full w-full object-cover object-left-top" data-id="element-528" data-mp="360mj1aman8tk" />
        </div>
      </div>
    </div>;
}